import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
  NotificationSettingsDto,
  UpdateNotificationChannelCommand,
  UpdateNotificationPreferenceCommand
} from "homey-housing-lottery-app-dto";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class NotificationSettingsService {
  private readonly http = inject(HttpClient);

  getNotificationSettings() {
    return this.http.get<NotificationSettingsDto>(`${environment.apiUrl}/api/private/notification-settings`);
  }

  updateChannel(command: UpdateNotificationChannelCommand) {
    return this.http.put<void>(`${environment.apiUrl}/api/private/notification-settings/channel`, command);
  }

  updatePreference(command: UpdateNotificationPreferenceCommand) {
    return this.http.put<void>(`${environment.apiUrl}/api/private/notification-settings/preference`, command);
  }
}
